import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("profileToken") || null);
  const [profile, setProfile] = useState(null);
  const [profileIncomplete, setProfileIncomplete] = useState(false); // ✅ NEW
  const baseURL = process.env.REACT_APP_API_URL;

  const isTokenExpired = (t) => {
    if (!t) return true;
    try {
      const decoded = jwtDecode(t);
      return decoded.exp < Date.now() / 1000;
    } catch {
      return true;
    }
  };

  // ✅ 5 fields required
  const isProfileComplete = (p) => {
    if (!p) return false;
    return (
      String(p.username || "").trim() &&
      String(p.fullname || "").trim() &&
      String(p.email || "").trim() &&
      String(p.mobile_no || "").trim() &&
      String(p.profile_pic || "").trim()
    );
  };

  const fetchProfileData = async (tok) => {
    try {
      const res = await axios.get(`${baseURL}/dashboard/me`, {
        headers: { "x-access-token": tok },
      });

      if (res.data.status && res.data.result) {
        setProfile(res.data.result);

        // ✅ locked popup flag
        setProfileIncomplete(!isProfileComplete(res.data.result));
      } else {
        setProfile(null);
        setProfileIncomplete(false);
      }
    } catch (err) {
      console.error("Failed to fetch profile:", err);
      setProfile(null);
      setProfileIncomplete(false);
    }
  };

  useEffect(() => {
    if (!token) return;

    if (isTokenExpired(token)) {
      logout();
    } else {
      setIsAuthenticated(true);
      fetchProfileData(token);
    }

    const interval = setInterval(() => {
      if (isTokenExpired(token)) logout();
    }, 60 * 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const login = (newToken) => {
    localStorage.setItem("profileToken", newToken);
    setToken(newToken);
    setIsAuthenticated(true);
    fetchProfileData(newToken);
  };

  const logout = async () => {
    try {
      const tok = token || localStorage.getItem("profileToken");
      if (tok) {
        await axios.post(`${baseURL}/dashboard/logout`, {}, {
          headers: { "x-access-token": tok },
        });
      }
    } catch (e) {
      // ignore
    } finally {
      localStorage.removeItem("profileToken");
      setToken(null);
      setIsAuthenticated(false);
      setProfile(null);
      setProfileIncomplete(false);
      window.location.href = "/login";
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
        token,
        profile,
        setProfile,
        profileIncomplete,        // ✅ NEW
        setProfileIncomplete,     // ✅ NEW
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
